<app-header></app-header>
<div id="main" style="overflow-x: hidden;" *ngIf="isNewLandingPage || isMedParentPage">
  <router-outlet></router-outlet>
</div>
<div id="main" *ngIf="!isNewLandingPage && !isMedParentPage">
  <app-left-container></app-left-container>
  <app-right-container id="RightContainer"></app-right-container>
  <app-slider-container [@toggleClick]="visible"></app-slider-container>
</div>
<app-footer></app-footer>
<div *ngIf="global.loading" class="loadingWrapper" >
  <div class="inner">
      <mat-spinner></mat-spinner>
      <p>Downloading report...&nbsp;&nbsp;&nbsp;&nbsp;</p>
  </div>
</div>
